import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=5962ddea&scoped=true"
import script from "@/controllers/forgotPassword.js?vue&type=script&lang=js&external"
export * from "@/controllers/forgotPassword.js?vue&type=script&lang=js&external"
import style0 from "./ForgotPassword.styles.css?vue&type=style&index=0&id=5962ddea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962ddea",
  null
  
)

export default component.exports